<template>
  <div>
    <index-card :loading="loading && system_flags.length === 0" fluid>
      <template slot="header">
        <div class="system-flags-header d-flex align-center flex-wrap">
          <v-btn text icon large to="/" exact>
            <v-icon class="white--text">mdi-arrow-left</v-icon>
          </v-btn>
          <div class="ml-1 ml-sm-2">
            <div class="d-flex align-center">
              <v-icon class="white--text mr-2">mdi-cog</v-icon>
              <span class="headline white--text font-weight-medium mb-0">Configurações</span>
            </div>
            <p class="system-flags-subtitle mb-0 mt-1 white--text">
              Ligue ou desligue as funcionalidades do sistema
            </p>
          </div>
        </div>
      </template>
      <template slot="subheader">
        <div class="d-flex align-center flex-wrap" style="width: 100%">
          <v-text-field
            v-model="search"
            label="Pesquisar por chave ou descrição"
            append-icon="mdi-magnify"
            single-line
            hide-details
            dense
            clearable
            outlined
            class="system-flags-search"
            color="primary"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-data-table
          class="elevation-0"
          :headers="headers"
          :items="system_flags"
          :search="search"
          :loading="loading"
          :footer-props="{ itemsPerPageOptions: [10, 30, 50, 100] }"
          mobile-breakpoint="1"
        >
          <template v-slot:item.kind="{ item }">
            <v-chip small outlined color="primary">
              {{ kinds_map[item.kind] || item.kind }}
            </v-chip>
          </template>

          <template v-slot:item.description="{ item }">
            {{ item.description || '—' }}
          </template>

          <template v-slot:item.enabled="{ item }">
            <v-switch
              v-model="item.enabled"
              color="success"
              class="mt-0 pt-0 d-inline-flex"
              hide-details
              :loading="updating_id === item.id"
              :disabled="updating_id === item.id"
              @change="toggleFlag(item)"
            ></v-switch>
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" type="info" outlined class="ma-4" icon="mdi-information-outline">
              Não há configurações para exibir.
            </v-alert>
          </template>

          <template v-slot:no-results>
            <v-alert :value="true" type="warning" outlined class="ma-4" icon="mdi-magnify-close">
              Não foi possível encontrar resultados para "{{ search }}".
            </v-alert>
          </template>
        </v-data-table>
      </template>
    </index-card>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="4000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'SystemFlags',
  components: {
    IndexCard: () => import('@/_backoffice/_registrations/components/shared/index/IndexCard.vue'),
  },
  data() {
    return {
      system_flags: [],
      loading: false,
      updating_id: null,
      search: '',
      snackbar: {
        show: false,
        color: 'success',
        text: '',
      },
      kinds_map: {
        feature: 'Funcionalidade',
        bugfix: 'Correção',
        security: 'Segurança',
        other: 'Outro',
        development: 'Desenvolvimento',
        system_functionality: 'Funcionalidade do sistema',
      },
      headers: [
        { text: 'Chave', align: 'left', sortable: true, value: 'key' },
        { text: 'Descrição', align: 'left', sortable: true, value: 'description' },
        { text: 'Tipo', align: 'center', sortable: true, value: 'kind' },
        { text: 'Ativo', align: 'center', sortable: true, value: 'enabled' },
      ],
    };
  },
  mounted() {
    this.getSystemFlags();
  },
  methods: {
    getSystemFlags() {
      this.loading = true;
      Api.SystemFlag.index()
        .then((res) => {
          this.system_flags = res.data.data.map((flag) => ({
            id: flag.id,
            ...flag.attributes,
          }));
        })
        .catch((err) => {
          console.log(err);
          this.notify('Não foi possível carregar as configurações', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleFlag(item) {
      this.updating_id = item.id;
      Api.SystemFlag.update(item.id, { enabled: item.enabled })
        .then(() => {
          this.notify(`"${item.key}" ${item.enabled ? 'ativada' : 'desativada'} com sucesso`, 'success');
        })
        .catch((err) => {
          item.enabled = !item.enabled;
          const message = err?.response?.data?.errors?.[0] || 'Não foi possível atualizar a configuração';
          this.notify(message, 'error');
        })
        .finally(() => {
          this.updating_id = null;
        });
    },
    notify(text, color) {
      this.snackbar = { show: true, color, text };
    },
  },
};
</script>

<style scoped>
.system-flags-header {
  width: 100%;
  gap: 8px;
}

.system-flags-subtitle {
  font-size: 0.8125rem;
  opacity: 0.88;
  line-height: 1.35;
}

.system-flags-search {
  max-width: 100%;
}

@media (min-width: 600px) {
  .system-flags-search {
    max-width: 420px;
  }
}
</style>
